import React from 'react'
import { Stamp } from './style'

const dataTestLabel = 'seal_videochamada'
const StampVideoChamada = ({ daInfo = false }) => (
  <Stamp daInfo={daInfo} data-test-component={dataTestLabel} />
)

export default StampVideoChamada
